import React, { useState } from 'react';
import { TiArrowBack } from "react-icons/ti";
import expressoDetalle from '../../imagenes/expresso-detalle.jpg';
import latteDetalle from '../../imagenes/detalle-latte.jpg';
import capuccinoDetalle from '../../imagenes/detalle-cappuccino.jpg';
import americanoDetalle from '../../imagenes/detalle-americano.jpg';
import mokaDetalle from '../../imagenes/detalle-moka.jpg';
import hotDetalle from '../../imagenes/detalle-chocolate.jpg';
import strawberryDetalle from '../../imagenes/detalle-smoothies-strawberry.jpg'
import naranjaDetalle from '../../imagenes/detalle-smoothies-naranja.jpg'
import verdeDetalle from '../../imagenes/detalle-smoothies-verde.jpg'
import chocolateDetalle from '../../imagenes/detalle-smoothies-chocolate.jpg'
import bettiesDetalle from '../../imagenes/detalle-smoothies-betties.jpg'
import cakeDetalle from '../../imagenes/detalle-cake.jpg'
import cookiesDetalle from '../../imagenes/detalle-cookies.jpg'
import croissantDetalle from '../../imagenes/detalle-croasian.jpg'
import browniesDetalle from '../../imagenes/detalle-brownies.jpg'
import lemonDetalle from '../../imagenes/detalle-lemon-pie.jpg'
import cheeseDetalle from '../../imagenes/detalle-cheesecake.jpg'
import cupcakeDetalle from '../../imagenes/detalle-cupcake.jpg'
import cesarDetalle from '../../imagenes/detalle-cesar.jpg'
import waldorDetalle from '../../imagenes/detalle-waldorf.jpg'
import capresseDetalle from '../../imagenes/detalle-capresse.jpg'
import atunDetalle from '../../imagenes/detalle-atun.jpg'
import polloDetalle from '../../imagenes/detalle-pollo.jpg'



import './ProductGrid.css';

const ProductGrid = ({ category, onBack, onProductSelect }) => { 
  // Definición completa de productos por categoría
  const getProductsByCategory = (cat) => {
    const products = {
      coffee: [
        { id: 1, name: 'Expresso', price: 3.75, description: 'Strong and bold coffee',image: expressoDetalle, backgroundImage: expressoDetalle},
        { id: 2, name: 'Latte', price: 4.00, description: 'Smooth coffee with steamed milk',image: latteDetalle , backgroundImage: latteDetalle  },
        { id: 3, name: 'Cappuccino', price: 4.50, description: 'Espresso with foamed milk',image: capuccinoDetalle, backgroundImage:capuccinoDetalle  },
        { id: 4, name: 'Americano', price: 3.00, description: 'Espresso with hot water',image: americanoDetalle, backgroundImage: americanoDetalle },
        { id: 5, name: 'Moka', price: 5.25, description: 'Rich chocolate coffee',image: mokaDetalle, backgroundImage: mokaDetalle  },
        { id: 6, name: 'Hot Chocolate', price: 5.75, description: 'Creamy chocolate drink',image: hotDetalle, backgroundImage: hotDetalle  } 
      ],
      smoothies: [
        { id: 7, name: 'Orange', price: 6.00, description: 'Fresh orange smoothie',image: naranjaDetalle, backgroundImage: naranjaDetalle },
        { id: 8, name: 'Green', price: 6.50, description: 'Healthy green smoothie',image: verdeDetalle, backgroundImage: verdeDetalle },
        { id: 9, name: 'Chocolate', price: 7.00, description: 'Rich chocolate smoothie',image: chocolateDetalle, backgroundImage: chocolateDetalle },
        { id: 10, name: 'Strawberry', price: 7.75, description: 'Sweet strawberry smoothie',image: strawberryDetalle, backgroundImage: strawberryDetalle},
        { id: 11, name: 'Frutos Rojos', price: 8.00, description: 'Mixed berries smoothie',image: bettiesDetalle, backgroundImage: bettiesDetalle }
      ],
      bakery: [
        { id: 12, name: 'Cake', price: 5.00, description: 'Delicious cake slice',image: cakeDetalle, backgroundImage: cakeDetalle },
        { id: 13, name: 'Cookies', price: 1.75, description: 'Fresh baked cookies',image: cookiesDetalle, backgroundImage: cookiesDetalle },
        { id: 14, name: 'Croissant', price: 2.75, description: 'Buttery croissant',image:croissantDetalle, backgroundImage: croissantDetalle },
        { id: 15, name: 'Brownies', price: 3.50, description: 'Chocolate brownie',image: browniesDetalle, backgroundImage: browniesDetalle },
        { id: 16, name: 'Lemon Pie', price: 6.50, description: 'Tangy lemon dessert',image: lemonDetalle, backgroundImage: lemonDetalle },
        { id: 17, name: 'Cheese Cake', price: 8.25, description: 'Creamy cheese cake',image: cheeseDetalle, backgroundImage: cheeseDetalle },
        { id: 18, name: 'Cupcake', price: 4.25, description: 'Delicate cupcake',image: cupcakeDetalle, backgroundImage: cupcakeDetalle }
      ],
      salads: [
        { id: 19, name: 'Cesar', price: 10.50, description: 'Classic Caesar salad' ,image: cesarDetalle, backgroundImage: cesarDetalle  },
        { id: 20, name: 'Waldorf', price: 12.25, description: 'Apple walnut salad' ,image: waldorDetalle, backgroundImage: waldorDetalle  },
        { id: 21, name: 'Capresse', price: 11.75, description: 'Tomato mozzarella salad' ,image: capresseDetalle, backgroundImage: capresseDetalle  },
        { id: 22, name: 'Atún', price: 14.00, description: 'Tuna salad' ,image: atunDetalle, backgroundImage: atunDetalle  },
        { id: 23, name: 'Pollo', price: 9.90, description: 'Chicken salad' ,image: polloDetalle, backgroundImage: polloDetalle }
      ]
    };
    return products[cat] || products.coffee;
  };

  const products = getProductsByCategory(category);

  if (!products || products.length === 0) {
    return (
      <div className="product-grid empty">
        <p>No hay producto disponible en esta categoria</p>
        {onBack && (
          <button className="back-to-home-btn" onClick={onBack}>
            Back to Home
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="product-grid-container">
      <h2 className="category-title">
        {category.charAt(0).toUpperCase() + category.slice(1)} Menu
      </h2>
      
      <div className="product-grid">
        {products.map(product => (
         <div
            key={product.id}
            className="product-card"
            onClick={() => onProductSelect && onProductSelect(product)}
          >
            {product.image && (
              <div className="product-image-container">
                <img 
                  src={product.image}
                  alt={product.name}
                  className="product-image"
                />
              </div>
            )}
            <h3 className="product-name">{product.name}</h3>
            <p className="product-description">{product.description}</p>
            <p className="product-price">${product.price.toFixed(2)}</p>
            <button 
              className="add-to-cart-btn"
              onClick={(e) => {
              e.stopPropagation();
              onProductSelect && onProductSelect(product);
              }}
              >
              Agregar al carrito 
            </button>
          </div>
        ))}
      </div>
      
      {onBack && (
        <div className="menu-actions">
          <button className="back-to-home-btn" onClick={onBack}>
            Back to Home
          </button>
        </div>
      )}
    </div>
  );
};

export default ProductGrid;